module.exports = __webpack_public_path__ + "img/icn_cv.3d4d2ab2.svg";